import produce from 'immer';
import {
  GET_LLM_CONFIG,
  ADD_LLM_CONFIG,
  UPDATE_LLM_CONFIG,
  DELETE_LLM_CONFIG
} from 'src/actions/llmCompletionConfig';

const initialState = {
  config: null
};

const llmCompletionConfigReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_LLM_CONFIG: {
      const { config } = action.payload;
      return produce(state, draft => {
        draft.config = config;
      });
    }

    case ADD_LLM_CONFIG: {
      const { config } = action.payload;
      return produce(state, draft => {
        draft.config = config;
      });
    }

    case UPDATE_LLM_CONFIG: {
      const { config } = action.payload;
      return produce(state, draft => {
        draft.config = config;
      });
    }

    case DELETE_LLM_CONFIG: {
      return produce(state, draft => {
        draft.config = null;
      });
    }

    default: {
      return state;
    }
  }
};

export default llmCompletionConfigReducer; 